//
//

import { mapMutations, mapGetters, mapActions } from "vuex";
import ConsumePage from "@/components/api/consume/consumedAPI.vue";
import ExposedPage from "@/components/api/exposed/exposedAPI.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import { infoToastPublish } from "@/assets/js/appFunc";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQHistory from "@/components/Generics/AQHistory/AQHistory.vue";
import NewApiModal from "./newApiModal/newApiModal.vue";

export default {
    name: "Apis",
    components: {
        ConsumePage,
        ExposedPage,
        NewApiModal,
        AQButton,
        AQModal,
        AQHistory
    },
    props: {
        value: Boolean
    },
    data() {
        return {
            pageName: "Api",
            page: "ConsumePage",
            showDlg: false,
            consumeActive: false,
            exposeActive: false,
            internalActive: false,
            allApis: false,
            firstLoad: false,
            isValid: true,
            selectTab: "",
            skeletonState: true,
            changeHistoryData: [],
            changeHistoryModal: false,
            changeHistoryCurrentPage: 0,
            changeHistoryHasMoreItems: true,
            selectTabHistory: "",
            prevSelectTabHistory: "",
            displayHistory: true
        };
    },
    computed: {
        ...mapGetters("apis", ["allExposedApis", "allConsumedApis", "getAllInternalApis"]),
        ...mapGetters("apps", ["currentApp", "getCurrentAppUserPermissions"]),
        isReadOnly() {
            return this.$route.params && this.$route.params.permissions
                ? this.$route.params.permissions.readonly
                : null;
        }
    },
    watch: {
        selectTab: {
            handler(value) {
                if (!this.firstLoad) {
                    if (value === "consumed-tab") {
                        this.getConsumedApis();
                    } else if (value === "exposed-tab") {
                        this.getExposedApis();
                    } else if (value === "internal-tab") {
                        this.getSystemApis();
                    }
                    this.setActiveTabHistory();
                }
            }
        },
        selectTabHistory: {
            handler(newValue, oldValue) {
                this.prevSelectTabHistory = oldValue || this.selectTab;
                if (newValue.length && newValue !== oldValue) {
                    this.displayHistory = false;
                    this.setActiveTabHistory(newValue);
                }
            }
        }
    },
    created() {
        this.$store.commit(
            "main/setSaveBtnVisible",
            this.$route.params && this.$route.params.permissions
                ? this.$route.params.permissions.readonly
                : false
        );
        this.checkActiveRoute();
    },
    mounted() {
        if (this.$route.query && this.$route.query.fromExposed) {
            this.selectTab = "exposed-tab";
        }
        this.setActiveTabHistory();
        this.firstLoad = true;
        this.checkPathValidity();
        let checkedButtonState = true;
        if (!this.allExposedApis.length && !this.allConsumedApis.length && !this.getAllInternalApis.length) {
            checkedButtonState = false;
        }
        this.$root.$emit("showCheckedSaveBtn", checkedButtonState);
    },
    activated() {
        if (!this.firstLoad) {
            this.$store.commit(
                "main/setSaveBtnVisible",
                this.$route.params && this.$route.params.permissions
                    ? this.$route.params.permissions.readonly
                    : false
            );
        } else {
            this.$store.commit(
                "main/setSaveBtnVisible",
                this.$route.params && this.$route.params.permissions
                    ? this.$route.params.permissions.readonly
                    : false
            );
            this.firstLoad = false;
        }
        this.$store.commit("rules/setShowRuleTesting", false);
        this.$root.$emit("showCheckedSaveBtn", true);
        this.$root.$emit("setReadonlyTag", this.$route.params && this.$route.params.permissions ? this.$route.params.permissions.readonly : false);
        this.$root.$on("backendWebsocketEvents-publishedApp", data => {
            infoToastPublish(data);
            this.$root.$emit("changePublishError");
        });
        this.$root.$on("showMoreChangeHistory", routeName => {
            if (routeName === this.$route.name) {
                this.changeHistoryCurrentPage += 1;
                this.getChangeHistory();
            }
        });
        this.$root.$on("openChangeHistory", routeName => {
            if (routeName === this.$route.name) {
                this.resetChangeHistory();
                this.getChangeHistory();
            }
        });
    },

    deactivated() {
        this.$store.commit("main/setSaveBtnVisible", false);
        this.$root.$emit("setReadonlyTag", false);
        this.$root.$off("backendWebsocketEvents-publishedApp");
        this.firstLoad = true;
        this.skeletonState = true;
        this.$store.commit("apis/setAllConsumedApis", []);
        this.$store.commit("apis/setAllExposedApis", { data: [] });
        this.$root.$off("openChangeHistory");
        this.resetChangeHistory();
    },

    methods: {
        ...mapMutations("main", ["setInterfaceDirty"]),
        ...mapActions("apis", ["getAllConsumedApis", "getAllExposedApis", "getAllSystemApis", "recoverApi"]),
        ...mapActions("apps", ["actGetCurrentAppUserPermissions", "getAppSettingsInfo"]),
        ...mapActions("components", ["getHistoryData"]),
        getExposedApis() {
            this.skeletonState = true;
            if (this.isValid) {
                this.getAllExposedApis().then(() => {
                    this.skeletonState = false;
                });
            }
        },
        getConsumedApis() {
            this.skeletonState = true;
            if (this.isValid) {
                this.getAllConsumedApis().then(() => {
                    this.skeletonState = false;
                });
            }
        },
        getSystemApis() {
            this.skeletonState = true;
            if (this.isValid) {
                this.getAllSystemApis().then(() => {
                    this.skeletonState = false;
                });
            }
        },
        checkPathValidity() {
            if (
                !this.currentApp
                || (this.currentApp && Object.keys(this.currentApp).length === 0)
            ) {
                this.$router.replace("/applications");
                this.isValid = false;
            } else {
                this.isValid = true;
            }
        },
        openDlg() {
            this.showDlg = true;
        },
        checkActiveRoute() {
            if (this.$router.currentRoute.name === "expose") {
                this.selectTab = "exposed-tab";
                this.getExposedApis();
            } else if (this.$router.currentRoute.name === "consumed") {
                this.selectTab = "consumed-tab";
                this.getConsumedApis();
            } else if (this.$router.currentRoute.name === "internalApis") {
                this.selectTab = "internal-tab";
                this.getSystemApis();
            }
        },
        resetChangeHistory() {
            this.changeHistoryData = [];
            this.changeHistoryCurrentPage = 0;
            this.changeHistoryHasMoreItems = true;
            this.prevSelectTabHistory = this.selectTabHistory;
        },
        getChangeHistory() {
            if (this.changeHistoryHasMoreItems) {
                const payload = {
                    searchType: "CHANGE_HISTORY",
                    module: this.getHistoryModule(),
                    applicationId: this.currentApp.id,
                    page: this.changeHistoryCurrentPage,
                    size: 10
                };
                this.getHistoryData(payload).then(data => {
                    if (data && data.data && data.data.history) {
                        this.changeHistoryData = this.changeHistoryData.concat(data.data.history);
                        this.changeHistoryHasMoreItems = data.data.hasMorePages;
                    }
                    this.displayHistory = true;
                    this.changeHistoryModal = true;
                });
            } else {
                this.displayHistory = true;
                this.changeHistoryModal = true;
            }
        },
        getHistoryModule() {
            const currentTab = this.selectTabHistory || this.selectTab;
            return currentTab === "exposed-tab" ? "APICredentials" : "APIExternal";
        },
        modalAction(evt) {
            if (evt === "close") {
                this.changeHistoryModal = false;
                this.prevSelectTabHistory = "";
                this.selectTabHistory = this.selectTab === "exposed-tab" ? "exposed-tab" : "consumed-tab";
            }
        },
        menuItemChangeHistoryClicked(evt) {
            const currentModule = this.getHistoryModule();
            if ((evt.menuOptionClicked === "recover") && (currentModule === "APIExternal")) {
                const payload = {
                    module: currentModule,
                    applicationId: this.currentApp.id,
                    elementId: evt.elementId,
                    commitId: evt.items[0].commitId
                };
                this.recoverApi(payload).then(response => {
                    if (response && response.data) {
                        if (response.data.isSuccessful === true) {
                            this.changeHistoryModal = false;
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("versioning.apiRecovered"),
                                timeout: 2000,
                                hasClose: true
                            });
                            this.checkFreshAppData();
                        } else {
                            const errorCodes = {
                                ALREADY_RECOVERED: this.$t("versioning.apiAlreadyRecovered"),
                                MISSING_API: this.$t("versioning.apiNotFound"),
                                NOT_DELETE: this.$t("versioning.interfaceNotDeleteEvent")
                            };
                            if (errorCodes[response.data.errorCode]) {
                                this.$toast.showNotify({
                                    type: "error",
                                    message: errorCodes[response.data.errorCode],
                                    timeout: 3000,
                                    hasClose: true
                                });
                            }
                        }
                    }
                });
            }
        },
        setActiveTabHistory(val) {
            if (typeof val === "undefined" || (val && val !== this.selectTabHistory)) {
                const currentTab = val || this.selectTab;
                this.prevSelectTabHistory = currentTab;
                this.selectTabHistory = currentTab === "exposed-tab" ? "exposed-tab" : "consumed-tab";
            }
        },
        clickTabHistory() {
            if (this.selectTabHistory !== this.prevSelectTabHistory) {
                this.resetChangeHistory();
                this.getChangeHistory();
            }
            this.prevSelectTabHistory = this.selectTabHistory;
        },
        checkFreshAppData() {
            this.getAppSettingsInfo(this.currentApp).then(data => {
                this.currentApp.publishStatus = data.data.publishStatus;
                this.$store.commit("apps/setCurrentApp", this.currentApp);
            });
        }
    }
};
